export class StatusBarModel {
    value: number;
    color: string;
    legend: string;
    ariaLabel?: string;
}
